module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<style>\n    .spl-form__page__settings .table > div > div {\n        padding : 5px 10px;\n    }\n\n    .spl-form__page__settings .columns {\n        table-layout : fixed;\n    }\n\n    .spl-form__page__settings .columns .title {\n        width: 25%;\n    }\n\n    .spl-form__page__settings .columns .column-row > div {\n        width         : 25%;\n        overflow      : hidden;\n        text-overflow : ellipsis;\n    }\n</style>\n\n<div class=\"form__page spl-form__page spl-form__page__settings\">\n    <div>\n        <div class=\"table w100\">\n            <div>\n                <div class=\"title\">Кол-во строк</div>\n                <div>")
    ; __append(escapeFn( widget.options.meta.count ))
    ; __append("</div>\n            </div>\n            <div>\n                <div class=\"title\">Тип геометрии</div>\n                <div>")
    ; __append(escapeFn( widget.options.meta.geometryType ))
    ; __append("</div>\n            </div>\n            <div>\n                <div class=\"title\">Проекция</div>\n                <div>\n                    <control type=\"data-autocomplete\" target=\"options.projectionname\" source=\"GIS.Data.Projections\"\n                             column=\"name\" columns=\"name\" bind=\"options.projection:code\" strict=\"true\"/>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class=\"table w100 columns\">\n        <div>\n            <div class=\"title\">Поля файла</div>\n            <div class=\"title\">Данные поля</div>\n            <div class=\"title\">Поля класса</div>\n            <div class=\"title\">Опции</div>\n        </div>\n        ")
    ;  _.each(widget.options.meta.columns, function(col, idx) { 
    ; __append("\n        <div class=\"column-row\" name=\"column-row-")
    ; __append(escapeFn( idx ))
    ; __append("\">\n            <div>")
    ; __append(escapeFn( col ))
    ; __append("</div>\n            <div>")
    ; __append(escapeFn( widget.options.meta.firstDataRow[idx] ))
    ; __append("</div>\n            <div name=\"column-")
    ; __append(escapeFn( idx ))
    ; __append("\">\n                <select data-file-column=\"")
    ; __append(escapeFn( idx ))
    ; __append("\" on-change=\"onSelectColumn\">\n                    <option></option>\n                    ")
    ;  _.each(widget.options.columns, function(col) { 
    ; __append("\n                    <option\n                        value=\"")
    ; __append(escapeFn( col.name ))
    ; __append("\"\n                        ")
    ; __append( widget.options.selectedColumns[idx] && widget.options.selectedColumns[idx].name === col.name ?
                            'selected' :
                            ''
                        )
    ; __append("\n                    >\n                        ")
    ; __append(escapeFn( col.title ))
    ; __append("\n                    </option>\n                    ")
    ;  }) 
    ; __append("\n                </select>\n            </div>\n            <div name=\"options-")
    ; __append(escapeFn( idx ))
    ; __append("\"></div>\n        </div>\n        ")
    ;  }) 
    ; __append("\n    </div>\n</div>\n")
  }
  return __output.join("");

}